import { IScope } from "../../../../global";
import { REF_VALUE_MARK } from "./common";
import Values from "./values";

export default function ReferenceValues({ scope }: { scope: IScope }) {
    return <Values scope={scope} mark={REF_VALUE_MARK} type='reference' />
}